
export const MESSAGES_FETCH = 'MESSAGES_FETCH';
export const MESSAGES_SUCCESS = 'MESSAGES_SUCCESS';
export const MESSAGES_FAILURE = 'MESSAGES_FAILURE';
export const MESSAGES_RESET = 'MESSAGES_RESET';
export const SAVE_MESSAGES = 'SAVE_MESSAGES';
export const RESTORE_MESSAGES = 'RESTORE_MESSAGES';

export const MESSAGES_REQUEST_EPIC = 'MESSAGES_REQUEST_EPIC';

export function requestMessage( message ) {
	let id_name = {};

	switch( message.pmroute ) {
		case 'pmfolder':
			id_name = { pmfolder: message.id };
			break;
		case 'pm':
			id_name = { pm: message.id };
			break;
	}

	return {
		type: MESSAGES_FETCH,
		loadingBehavior: message.loadingBehavior,
		...id_name
	};
}

export function receiveMessages( route, id, data, loadingBehavior ) {
	return {
		type: MESSAGES_SUCCESS,
		pmroute: route,
		id: id,
		data: data,
		loadingBehavior: loadingBehavior
	};
}

export function failedMessages( route, id, error ) {
	return {
		type: MESSAGES_FAILURE,
		pmroute: route,
		id: id,
		error: error
	};
}

export function resetMessages(){
	return {
		type: MESSAGES_RESET
	};
}

export const saveMessages = () => {
	return {
		type: SAVE_MESSAGES
	}
}

export const restoreMessages = () => {
	return {
		type: RESTORE_MESSAGES
	}
}

export function requestMessagesEpic(messagesRequest) {
	return {
		type: MESSAGES_REQUEST_EPIC,
		messagesRequest
	}
}


// WEBPACK FOOTER //
// ./common/actions/MessagesviewActions.js